var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('PrimaryButton',{attrs:{"disabled":!_vm.isContinueButtonEnabled,"fullWidth":true,"loading":_vm.buttonLoading,"className":"primary-btn__blue mt17","size":"large","text":"Continue"},on:{"onClick":_vm.onSubmit}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }